import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  GeneratedContentGenerationUpdateInput,
  GeneratedContentGenerationUpdatePayload
} from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentGenerationUpdateInput;
type TData = GeneratedContentGenerationUpdatePayload;

export const useContentGenerationUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentGenerationUpdate($input: GeneratedContentGenerationUpdateInput!) {
      generatedContentGenerationUpdate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
